<div class="navbar-header">

    <div class="logo">
        <img class="logo-icon" src="assets/images/logos/logo.jpg" style="max-width:45px;">
        <!-- <span class="logo-text">Life Asia ECS</span> -->
    </div>

    <button mat-button class="toggle-button-navbar mat-icon-button" fuseNavbarVertical="toggleFold" fxHide.lt-lg>
        <mat-icon>menu</mat-icon>
    </button>

    <button mat-button class="toggle-button-navbar mat-icon-button" fuseNavbarVertical="closeBar" fxHide.gt-md>
        <mat-icon>arrow_back</mat-icon>
    </button>

</div>

<div class="navbar-content" fusePerfectScrollbar>
    <fuse-navigation layout="vertical"></fuse-navigation>
</div>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/navbar/vertical/navbar-vertical.component.html